/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { FormItemWrapper, Textarea } from './common';
import FormError from './common/FormError';

const TextArea = (props) => {
  const { field, form, label, formType, rows = 15, required } = props;
  const { name } = field;
  const { touched, errors } = form;
  const error = errors[name];
  const touch = touched[name];
  return (
    <FormItemWrapper label={label} required={required} name={name}>
      <Textarea
        type={formType}
        {...field}
        rows={rows}
        id={name}
        hasError={touch && error}
      />
      <FormError touch={touch} error={error} />
    </FormItemWrapper>
  );
};

export default TextArea;
